import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from "@emotion/react";
import { useThemeProps, withDefaultProps, ListStack } from "@wsui/base";
import HitController from "./HitController.mjs";
function DefaultHits(props) {
  useTheme();
  props = useThemeProps({
    props,
    name: "AlgoliaDefaultHits"
  });
  let {
    hitComponent: Hit = HitController,
    as: Component = withDefaultProps(ListStack, {
      spacing: 4,
      divider: true,
      ordered: true
    }),
    hits,
    ownerState,
    ...restProps
  } = props;
  return /* @__PURE__ */jsx(Component, {
    ...restProps,
    children: hits.map((hit, index) => {
      return /* @__PURE__ */jsx(Hit, {
        hit,
        index,
        hitsOwnerState: ownerState
      }, index);
    })
  });
}
export { DefaultHits as default };